import "react-toastify/dist/ReactToastify.css";
import "./main.scss";

import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { PaymentProvider } from "./providers/payment/payment.provider";
import { setAppToken } from "./setup/context/api";
import React, { Suspense } from "react";
const NavBar = React.lazy(() => import("./components/navbar"));
const Routes = React.lazy(() => import("./setup/routes"));
const ScrollToTop = React.lazy(() => import("./components/common/scrollToTop"));

export const App = () => {
  // const notificationTitle = useTranslation().t("lbl_new_notification");

  // useEffect(() => {
  //   onMessageListener()
  //     .then(() => {
  //       toast.info(<h4> {notificationTitle} </h4>);
  //     })
  //     .catch((err) => console.log("failed: ", err));
  // }, [notificationTitle]);

  return (
    <div dir="rtl">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <Suspense fallback={<div />}>
        <ScrollToTop path="/">
          <PaymentProvider>
            <Router>
              <ToastContainer rtl={true} />
              <NavBar />
              <Routes />
            </Router>
          </PaymentProvider>
        </ScrollToTop>
      </Suspense>
    </div>
  );
};
setAppToken();
